<!--
 * @Author: 张星 448369965@qq.com
 * @Date: 2025-03-18 10:41:27
 * @LastEditors: 张星 448369965@qq.com
 * @LastEditTime: 2025-03-18 13:51:48
 * @FilePath: \dataview-next\src\custom-component\newPageContainer\CommonNewPageContainer.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="page-container">
    <iframe class="iframe" :src="computedUrl" frameborder="0"></iframe>
	</div>
</template>

<script>
import { getToken } from '@/utils/tools';
export default {
	name: 'CommonNewPageContainer',
	props: {
		element: {
			type: Object,
			required: true
		},
	},
	data() {
		return {
      host: ['page-editor.bimcc.site', 'localhost'].includes(window.location.hostname) ? 'https://dwh.bimcc.net' : window.location.origin,
      bimcctoken: getToken(),
		};
	},
	components: {
    
	},
	computed: {
    computedUrl () {
      return `${this.host}/rafter-design/page-render?page_uuid=${this.element?.newPageConfig?.page_uuid}&bimcctoken=${this.bimcctoken}`
    }
	},
	methods: {
	},
	mounted() {
	}
};
</script>

<style lang="less">
.page-container {
  width: 100%;
  height: 100%;
  .iframe{
    width: 100%;
    height: 100%;
  }
}
</style>